/**
 * AlmadarPostComplianceAsCodeSLAlmadarPostComplianceAsCodeSLPage
 *
 * Page component for AlmadarPostComplianceAsCodeSLAlmadarPostComplianceAsCodeSLPage
 * Path: /sl/blog/compliance-as-code
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { AlmadarPostComplianceAsCodeSLPostPageView as __AlmadarPostComplianceAsCodeSLPostPageView } from '@/components/traits/AlmadarPostComplianceAsCodeSLPostPageView';
import { AlmadarPostComplianceAsCodeSLPostAnalyticsView as __AlmadarPostComplianceAsCodeSLPostAnalyticsView } from '@/components/traits/AlmadarPostComplianceAsCodeSLPostAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';

interface AlmadarPostComplianceAsCodeSLAlmadarPostComplianceAsCodeSLPageProps {
  // Add any page-level props here
}

export function AlmadarPostComplianceAsCodeSLAlmadarPostComplianceAsCodeSLPage(_props: AlmadarPostComplianceAsCodeSLAlmadarPostComplianceAsCodeSLPageProps) {
  const __navState = (useLocation().state ?? {}) as EventPayload;

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__AlmadarPostComplianceAsCodeSLPostPageView config={{ initPayload: __navState }} />
          <__AlmadarPostComplianceAsCodeSLPostAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default AlmadarPostComplianceAsCodeSLAlmadarPostComplianceAsCodeSLPage;
